import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DateHelper  {
    _originalTypeClassName = "zERP.BO.DateHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DateHelper.translate = translateService;
}
this.DateHelperKey = null;
this._key = this.DateHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DateHelperKey:any;
get DateHelperKey(): any {
    return this._DateHelperKey;
  }
set DateHelperKey(value: any) {
    this._DateHelperKey = value;
    this._key = value;
  }

static DaysAreSame(date1: any,date2: any): any{return CLMS.Framework.Number.Equal(() => moment(date1).year(), () => moment(date2).year()) && CLMS.Framework.Number.Equal(() => (moment(date1).month() + 1), () => (moment(date2).month() + 1)) && CLMS.Framework.Number.Equal(() => moment(date1).date(), () => moment(date2).date());
}
static FirstOfNextMonth(date: any): any{let initialMonth = (moment(date).month() + 1);
while ((CLMS.Framework.Number.Equal(() => (moment(date).month() + 1), () => initialMonth))) {date = (moment(date).add(1.0, "d")).toDate();}
return date;
}
static GetCommonDays(range1Start: any,range1End: any,range2Start: any,range2End: any): any{let start = ((new Date(range1Start).getTime()) > (new Date(range2Start).getTime()) ? range1Start : range2Start);
let end = ((new Date(range1End).getTime()) > (new Date(range2End).getTime()) ? range2End : range1End);
if (((new Date(start).getTime()) > (new Date(end).getTime()))) {return 0;}
return Joove.Common.safeNumber(Joove.Common.dateDiff(end, start)?.days) + Joove.Common.safeNumber(1);
}
static GetDatePart(date: any): any{return moment([moment(date).year(), ((moment(date).month() + 1)) - 1, moment(date).date()]).toDate();
}
static GetDaysBetween(day1: any,day2: any): any{let days = 0;
if ((new Date(day1).getTime()) > (new Date(day2).getTime())) {return 0;}
while ((new Date(day1).getTime()) <= (new Date(day2).getTime())) {day1 = (moment(day1).add(1, "d")).toDate();days = Joove.Common.safeNumber(days) + Joove.Common.safeNumber(1);}
return days;
}
static GetLastDateOfMonth(date: any): any{let daysInMonth = moment("moment(date).year()-(moment(date).month()+1)", "YYYY-MM").daysInMonth();
return moment([moment(date).year(), ((moment(date).month() + 1)) - 1, daysInMonth, 12, 0, 0]).toDate();
}
static GetLastDateOfTheYear(year: any): any{if (CLMS.Framework.Number.Equal(() => year, () => null)) {year = moment(moment().toDate()).year();}
return moment([year, (12) - 1, 31, 12, 0, 0]).toDate();
}
static GetMaxDate(dates: any): any{return dates?.linq?.where((d) => !(Domain.DateHelper.IsDateNull(d)))?.toArray()?.linq?.orderByDescending((d) => d)?.toArray()?.linq?.where()?.firstOrDefault(null);
}
static GetMinDate(dates: any): any{return dates?.linq?.where((d) => !(Domain.DateHelper.IsDateNull(d)))?.toArray()?.linq?.orderBy((d) => d)?.toArray()?.linq?.where()?.firstOrDefault(null);
}
static GetNextDayOfWeek(from: any,dayOfWeek: any): any{let start = moment(from).day();
let target = dayOfWeek;
if (CLMS.Framework.Number.LessThanOrEqual(() => target, () => start)) {target = Joove.Common.safeNumber(target) + Joove.Common.safeNumber(7);}
return (moment(from).add(Joove.Common.safeNumber(target) - Joove.Common.safeNumber(start), "d")).toDate();
}
static GetOrthodoxEasterSunday(year: any): any{let a = Joove.Common.safeNumber(year) % Joove.Common.safeNumber(19);
let b = Joove.Common.safeNumber(year) % Joove.Common.safeNumber(7);
let c = Joove.Common.safeNumber(year) % Joove.Common.safeNumber(4);
let d = Joove.Common.safeNumber((Joove.Common.safeNumber(19) * Joove.Common.safeNumber(a) + Joove.Common.safeNumber(16))) % Joove.Common.safeNumber(30);
let e = Joove.Common.safeNumber((Joove.Common.safeNumber(2) * Joove.Common.safeNumber(c) + Joove.Common.safeNumber(4) * Joove.Common.safeNumber(b) + Joove.Common.safeNumber(6) * Joove.Common.safeNumber(d))) % Joove.Common.safeNumber(7);
let f = Joove.Common.safeNumber((Joove.Common.safeNumber(19) * Joove.Common.safeNumber(a) + Joove.Common.safeNumber(16))) % Joove.Common.safeNumber(30);
let key = Joove.Common.safeNumber(f) + Joove.Common.safeNumber(e) + Joove.Common.safeNumber(3);
let month = ((CLMS.Framework.Number.GreaterThan(() => key, () => 30)) ? 5 : 4);
let day = ((CLMS.Framework.Number.GreaterThan(() => key, () => 30)) ? Joove.Common.safeNumber(key) - Joove.Common.safeNumber(30) : key);
return moment([year, (month) - 1, day]).toDate();
}
static GetWeekNumberOfMonth(date: any): any{let firstMonthDay = moment([moment(date).year(), ((moment(date).month() + 1)) - 1, 1]).toDate();
let firstMonthMonday = (moment(firstMonthDay).add(Joove.Common.safeNumber((Joove.Common.safeNumber(8) - Joove.Common.safeNumber(moment(firstMonthDay).day()))) % Joove.Common.safeNumber(7), "d")).toDate();
if (((new Date(firstMonthMonday).getTime()) > (new Date(date).getTime()))) {firstMonthDay = (moment(firstMonthDay).add(-1, "M")).toDate();firstMonthMonday = (moment(firstMonthDay).add(Joove.Common.safeNumber((Joove.Common.safeNumber(8) - Joove.Common.safeNumber(moment(firstMonthDay).day()))) % Joove.Common.safeNumber(7), "d")).toDate();}
return Joove.Common.safeNumber(Math.abs(Joove.Common.dateDiff(date, firstMonthMonday)?.days)) / Joove.Common.safeNumber(7) + Joove.Common.safeNumber(1);
}
static GreekHourToUTC(hour: any): any{return Joove.Common.safeNumber(hour) - Joove.Common.safeNumber(3);
}
static IsDateEqualOrLessThan(thisDate: any,date: any): any{let thisDateDate = Domain.DateHelper.GetDatePart(thisDate);
let dateDate = Domain.DateHelper.GetDatePart(date);
return (new Date(thisDateDate).getTime()) <= (new Date(dateDate).getTime());
}
static IsDateEqualOrMoreThan(thisDate: any,date: any): any{let thisDateDate = Domain.DateHelper.GetDatePart(thisDate);
let dateDate = Domain.DateHelper.GetDatePart(date);
return (new Date(thisDateDate).getTime()) >= (new Date(dateDate).getTime());
}
static IsDateNull(date: any): any{return date == null || (new Date(date).getTime()) == (new Date().getTime()) || (new Date(date).getTime()) == (new Date(moment(-8640000000000000).toDate()).getTime());
}
static SelectIfNotEmpty(targetDate: any,defaultDate: any): any{if (!(Domain.DateHelper.IsDateNull(targetDate))) {return targetDate;}
return defaultDate;
}
static ToEndOfDayDate(date: any): any{return moment([moment(date).year(), ((moment(date).month() + 1)) - 1, moment(date).date(), 23, 59, 59]).toDate();
}
static ToStartOfDayDate(date: any): any{return moment([moment(date).year(), ((moment(date).month() + 1)) - 1, moment(date).date(), 0, 0, 0]).toDate();
}
static TryToParse(inputDate: any): any{if (inputDate == null) {return null;}
inputDate = inputDate?.trim();
if (CLMS.Framework.Number.Equal(() => inputDate.length, () => 10)) {return CLMS.Framework.DateTime.ParseExact(inputDate, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "dd/MM/yyyy").toDate();}else if (CLMS.Framework.Number.Equal(() => inputDate.length, () => 9) && CLMS.Framework.Number.Equal(() => inputDate.indexOf("/"), () => 2)) {return CLMS.Framework.DateTime.ParseExact(inputDate, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "dd/M/yyyy").toDate();}else if (CLMS.Framework.Number.Equal(() => inputDate.length, () => 9) && CLMS.Framework.Number.Equal(() => inputDate.indexOf("/"), () => 1)) {return CLMS.Framework.DateTime.ParseExact(inputDate, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "d/MM/yyyy").toDate();}else if (CLMS.Framework.Number.Equal(() => inputDate.length, () => 8)) {return CLMS.Framework.DateTime.ParseExact(inputDate, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "d/M/yyyy").toDate();}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DateHelperKey == null || $this.DateHelperKey == 0;
            }


}